import React, { Component } from 'react';
import './App.css';
import ArrowButton from './ArrowButton';
import 'muicss/dist/css/mui-noglobals.min.css';
import Textarea from 'muicss/lib/react/textarea';
import Input from 'muicss/lib/react/input';

class ContactForm extends Component {
	constructor(props) {
      super(props)
      this.state = { 
        email: null,
        contactname:null,
        taval:null,
        sendSuccess: false
      }
	 this.onSubmit=this.onSubmit.bind(this)
	}

  onChange(ev) {
    console.log(ev.target+this.state.taval);
    const target = ev.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onSubmit(){
    //console.log(JSON.stringify(this.state));
    var newbody = { email:this.state.email,name:this.state.contactname,message:this.state.taval }

    //production
    var url='http://oddmachine.design:443/emailjson'
    //var url='http://localhost:8080/emailjson'
    fetch(url, {
      method: 'POST', // or 'PUT'
      // data can be `string` or {object}!
      headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
      },
      body: JSON.stringify(newbody)
    }).then(res => res.json())
    .catch(error => console.error('Error:', error))
    .then(response => 
      console.log('Success:', response,
      this.setState({sendSuccess:true})
    ));
  }

  render() {
  	

    return (
      <form onSubmit={this.onSubmit.bind(this)}>
        <Input style={{width:'30em'}} name='contactname' onChange={this.onChange.bind(this)} floatingLabel={true} label="name" placeholder="name" />
        <Input style={{width:'30em'}} name='email' onChange={this.onChange.bind(this)} required={true} floatingLabel={true} label="email" placeholder="email" />
        <Textarea style={{width:'30em'}} name='taval' onChange={this.onChange.bind(this)} required={true} label="message" rows="5" cols="50" defaultValue="" placeholder="Let's keep it short . . . " /> 
        <ArrowButton btlabel="SEND" buttonCB={this.onSubmit} height="17" width="15" /> 
        <div className={this.state.sendSuccess ? 'notification show' : 'notification hide' }>Message sent successfully</div> 
      </form>

    )
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/ContactForm.js